import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Drawer, Divider } from 'antd';
import { isMobile } from 'react-device-detect';
import BaseSelect from '../../components/Elements/BaseSelect';
import CKEditorComponent from '../../components/Editor/CKEditorComponent';
import { _newLine } from '../../utils/helpers';
import { fetchActiveScheduleAreas } from '../../redux/actions/scheduleAreaActions';
import {
    createScheduleAreaFunction,
    updateScheduleAreaFunction
} from '../../redux/actions/scheduleAreaFunctionActions';

class ScheduleAreaFunctionForm extends Component {
    state = { isLoading: false };

    componentDidMount() {
        this.props.fetchActiveScheduleAreas().catch(() => null);
    }

    submit = event => {
        event.preventDefault();
        this.props.form.validateFields((error, values) => {
            if (error) return;

            const request = this.props.currentData
                ? this.props.updateScheduleAreaFunction(this.props.currentData.id, values)
                : this.props.createScheduleAreaFunction(values);

            this.setState({ isLoading: true });
            request
                .then(() => {
                    this.props.reloadData();
                    this.close();
                })
                .catch(() => null)
                .finally(() => this.setState({ isLoading: false }));
        });
    };

    close = () => {
        this.props.form.resetFields();
        this.props.onCancel();
    };

    render() {
        const { visible, currentData, activeAreas } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer
                visible={visible}
                title={currentData ? 'Sửa chức năng khu vực' : 'Thêm chức năng khu vực'}
                onClose={this.close}
                maskClosable={false}
                width={isMobile ? '100%' : '45%'}
                footer={(
                    <div style={{ textAlign: 'right' }}>
                        <Button onClick={this.close}>Huỷ</Button>
                        <Divider type="vertical" />
                        <Button type="primary" loading={this.state.isLoading} onClick={this.submit}>
                            {currentData ? 'Cập nhật' : 'Tạo'}
                        </Button>
                    </div>
                )}
            >
                {visible ? (
                    <Form layout="vertical">
                        <Form.Item label="Khu vực làm việc">
                            {getFieldDecorator('schedule_area_id', {
                                rules: [{ required: true, message: 'Vui lòng chọn khu vực.' }],
                                initialValue: currentData?.schedule_area_id || null
                            })(
                                <BaseSelect
                                    options={activeAreas}
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Chọn khu vực"
                                    showSearch
                                    style={{ width: '100%' }}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Mô tả chức năng">
                            {getFieldDecorator('description', {
                                rules: [{ required: true, message: 'Vui lòng nhập mô tả chức năng.' }],
                                initialValue: currentData?.description || ''
                            })(
                                <CKEditorComponent
                                    initialHeight="300px"
                                    editorData={currentData?.description}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Ghi chú">
                            {getFieldDecorator('note', {
                                initialValue: currentData ? _newLine(currentData.note) : ''
                            })(<Input.TextArea rows={3} />)}
                        </Form.Item>
                    </Form>
                ) : null}
            </Drawer>
        );
    }
}

const mapStateToProps = state => ({
    activeAreas: state.scheduleAreaReducer.activeItems
});

const mapDispatchToProps = dispatch => ({
    fetchActiveScheduleAreas: () => dispatch(fetchActiveScheduleAreas()),
    createScheduleAreaFunction: data => dispatch(createScheduleAreaFunction(data)),
    updateScheduleAreaFunction: (id, data) => dispatch(updateScheduleAreaFunction(id, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(
    Form.create({ name: 'ScheduleAreaFunctionForm' })(ScheduleAreaFunctionForm)
);
